// extracted by mini-css-extract-plugin
export default {"horizontalRule":"v5M4HqlYWpK0OhU1spJK"};